import env from 'config/env';

export const eConsumerLinkOptions = ['all', 'hasEconsumerLink', 'hasNoEconsumerLink'];
export const dataSharingEnabled = env.FEATURES.STAT_419521_CLIENT_DATA_SHARING;
export const allowAddNewClient = env.FEATURES.STAT_482932_ADD_NEW_CLIENT;
